module.exports = __webpack_public_path__ + "img/yuyin-data-list-0.e2059e2c.png";